import React from 'react';
import { FormattedMessage } from 'react-intl';
import InternationalizationStore from '../../../store/internationalization-store.js'
import { FormControl, FormGroup, ControlLabel, Row, Col } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import InternationalisationStore from '../../../store/internationalization-store.js';
import LanguageSelector from "../../inputs/language-selector.js";
import LanguageInterfaceSelector from "../../inputs/language-interface-selector.js";
import Select from 'react-select';

export default {
    name: <FormattedMessage id={'ui-330'} defaultMessage={'Printables'} />,
    title: null,
    onSubmit: function (done) {
        
        if(!this.props.data.selectedLanguage){
            return done(new Error(InternationalizationStore.getTranslation('ui-902' ,'Please Select A Language' )));
        } else {
            return done()
        }
    },
    value: null,
    component: React.createClass({
      
        componentDidMount: function () {
            var printables = [{ name: "Snap", text:<FormattedMessage id={'ui-328'} defaultMessage={'Snap'} />,},
             { name: "Flashcards", text: <FormattedMessage id={'ui-324'} defaultMessage={'Flashcards'}/>}, 
             { name: "Vocab List", text: <FormattedMessage id={'ui-329'} defaultMessage={'Vocab List'}/>},
            { name: "Dice", text: <FormattedMessage id={'ui-326'} defaultMessage={'Dice'}/> },
            { name: "Word Search", text: <FormattedMessage id={'ui-205'} defaultMessage={'Word Search'}/> }
        ]

        var levels = [{ name: "Level 1", text:<FormattedMessage id={'ui-147'} defaultMessage={'Level One'} />,},
        { name: "Level 2", text: <FormattedMessage id={'ui-148'} defaultMessage={'Level Two'}/>}, 
        { name: "Level 3", text: <FormattedMessage id={'ui-149'} defaultMessage={'Level Three'}/>}
        ]


            if(sessionStorage.product == "huber" || sessionStorage.getItem("product") == "klett" || 
                sessionStorage.getItem('product') == "larousse" || sessionStorage.getItem('product') == "hodder" || 
                sessionStorage.getItem('product') == "cornelson") {

                printables = [
                { name: "Vocab List", text: <FormattedMessage id={'ui-329'} defaultMessage={'Vocab List'}/>}]
            }
            this.options = printables.map(function (printable) {
                return { value: printable.name, label: printable.text }
            });
            this.levelOptions = levels.map(function (level) {
                return { value: level.name, label: level.text }
            });
            this.levelValue = this.levelOptions[0];
            this.value = this.options[0];
            this.props.data.printable = this.options[0].value;
            this.props.data.level = 1;
        },
        onSelect: function (e) {
            this.props.data.printable = e.value;
            this.value = e;
            this.setState({ value: e });
        },
        onSelectLevel: function (e) {
            var lvl = e.value;
            this.levelValue = e;
            if (lvl == "Level 1" ){
                this.props.data.level = 1;
            } else if (lvl == "Level 2"){
                this.props.data.level = 2;
            } else {
                this.props.data.level = 3;
            }
            this.setState({ levelValue: e });
        },
        handleSelectLanguage: function (language) {
            this.props.data.selectedLanguage = language;
            this.setState({selectedLanguage : language});
        },
        handleSelectInterfaceLanguage: function (language) {
            this.props.data.selectedInterfaceLanguage = language;
            this.setState({selectedInterfaceLanguage : language});
        },
        render: function () {
            if(sessionStorage.product == "huber" || sessionStorage.product == "pratstart" || sessionStorage.getItem('product') == "larousse") {
                return (
                <div>
                    <Row>
                        <Col sm={6}>
                            <FormGroup className="fg-line">
                                <ControlLabel className="fg-label"><FormattedMessage id={'ui-330'} defaultMessage={'Choose Printable'} /></ControlLabel>
                                <Select onChange={this.onSelect} options={this.options} value={this.value} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
                                placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
                            </FormGroup>
                        </Col>
    
                        <Col sm={6}>
                            <FormGroup className="fg-line">
                                <ControlLabel className="fg-label"><FormattedMessage id={'ui-847'} defaultMessage={'Choose Language'} /></ControlLabel>
                                <LanguageSelector onSelect={this.handleSelectLanguage} disabled={['ht', 'ur', 'ko']} />
                            </FormGroup>
                        </Col>
                         <Col sm={6}>
                            <FormGroup className="fg-line">
                                <ControlLabel className="fg-label"><FormattedMessage id={'ui-2175'} defaultMessage={'Choose Support Language'} /></ControlLabel>
                                <LanguageInterfaceSelector onSelect={this.handleSelectInterfaceLanguage} disabled={['ht', 'ur', 'ko']} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="p-b-20"></Row>
                </div>)

            } else if(this.value != undefined && this.value.value == "Word Search")
            {
                return (
                    <div>
                        <Row>
                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <ControlLabel className="fg-label"><FormattedMessage id={'ui-330'} defaultMessage={'Choose Printable'} /></ControlLabel>
                                    <Select onChange={this.onSelect} options={this.options} value={this.value} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
                                    placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
                                </FormGroup>
                            </Col>

                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <ControlLabel className="fg-label"><FormattedMessage id={'ui-9999999'} defaultMessage={'Choose Level'} /></ControlLabel>
                                    <Select onChange={this.onSelectLevel} options={this.levelOptions} value={this.levelValue} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
                                    placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
                                </FormGroup>
                            </Col>
        
        
                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <ControlLabel className="fg-label"><FormattedMessage id={'ui-847'} defaultMessage={'Choose Language'} /></ControlLabel>
                                    <LanguageSelector onSelect={this.handleSelectLanguage} disabled={['rj' , 'hz', 'hand','ja', 'ko' , 'prs', 'ps','fa','cn', 'ar', 'ht', 'ur', 'ko']} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="p-b-20"></Row>
                    </div>)
            
            }else {
            return (
                <div>
                    <Row>
                        <Col sm={6}>
                            <FormGroup className="fg-line">
                                <ControlLabel className="fg-label"><FormattedMessage id={'ui-330'} defaultMessage={'Choose Printable'} /></ControlLabel>
                                <Select onChange={this.onSelect} options={this.options} value={this.value} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
                                placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
                            </FormGroup>
                        </Col>
    
                        <Col sm={6}>
                            <FormGroup className="fg-line">
                                <ControlLabel className="fg-label"><FormattedMessage id={'ui-847'} defaultMessage={'Choose Language'} /></ControlLabel>
                                <LanguageSelector onSelect={this.handleSelectLanguage} disabled={['ht', 'ur', 'ko']} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="p-b-20"></Row>
                </div>)
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/components/wizard/printable-steps/select-printable.js